export const mockExpectedFlightData = [
    { lat: 0.929216202787225, lon: -0.0789034263911186, alt: 39.9368303037955 },
    { lat: 0.929216202988808, lon: -0.0789034260988396, alt: 39.8778791092682 },
    { lat: 0.929216202992891, lon: -0.0789034260929202, alt: 39.8768520065474 },
    { lat: 0.929216202993008, lon: -0.0789034260927532, alt: 39.8759990241246 },
    { lat: 0.929216203081033, lon: -0.0789034259651106, alt: 39.877300470426 },
    { lat: 0.929216203311406, lon: -0.078903425631055, alt: 39.877624464132 },
    { lat: 0.929216203537196, lon: -0.0789034253036443, alt: 39.8778964637379 },
    { lat: 0.929216203777997, lon: -0.0789034249544679, alt: 39.8781682873345 },
    { lat: 0.929216204068812, lon: -0.0789034245327644, alt: 39.878633581012 },
    { lat: 0.929216204384505, lon: -0.0789034240749867, alt: 39.8789922732163 },
    { lat: 0.929216204769615, lon: -0.0789034235165457, alt: 39.880013134355 },
    { lat: 0.929216205221402, lon: -0.0789034228614104, alt: 39.8804813180084 },
    { lat: 0.929216205671071, lon: -0.0789034222093502, alt: 39.8802032971383 },
    { lat: 0.92921620608435, lon: -0.0789034216100618, alt: 39.8797569715759 },
    { lat: 0.92921620645227, lon: -0.0789034210765513, alt: 39.8794359205948 },
    { lat: 0.929216206797653, lon: -0.0789034205757204, alt: 39.879249558849 },
    { lat: 0.929216207138037, lon: -0.0789034200821369, alt: 39.8791721758302 },
    { lat: 0.929216207477471, lon: -0.0789034195899338, alt: 39.8791768273256 },
    { lat: 0.929216207813301, lon: -0.0789034191029569, alt: 39.8792129405484 },
    { lat: 0.929216208153897, lon: -0.0789034186090677, alt: 39.8792630022141 },
    { lat: 0.929216208504351, lon: -0.0789034181008837, alt: 39.8793125806 },
    { lat: 0.929216208852089, lon: -0.0789034175966411, alt: 39.8793447559197 },
    { lat: 0.929216209201201, lon: -0.0789034170904059, alt: 39.8793677445267 },
    { lat: 0.929216209556813, lon: -0.0789034165747398, alt: 39.8793744148645 },
    { lat: 0.929216209917041, lon: -0.0789034160523806, alt: 39.8793680137976 },
    { lat: 0.929216210271056, lon: -0.0789034155390307, alt: 39.8793492674639 },
    { lat: 0.929216210617521, lon: -0.0789034150366308, alt: 39.8793446996042 },
    { lat: 0.929216210963193, lon: -0.0789034145353816, alt: 39.8793303063619 },
    { lat: 0.929216211313764, lon: -0.078903414027028, alt: 39.8793304468345 },
    { lat: 0.929216211665503, lon: -0.0789034135169823, alt: 39.8793486793654 },
    { lat: 0.929216212013767, lon: -0.0789034130119787, alt: 39.8793635688244 },
    { lat: 0.929216212362236, lon: -0.0789034125066748, alt: 39.8793735929619 },
    { lat: 0.929216212716466, lon: -0.0789034119930155, alt: 39.8793814199527 },
    { lat: 0.929216213070617, lon: -0.0789034114794684, alt: 39.8793855429578 },
    { lat: 0.92921621341897, lon: -0.0789034109743299, alt: 39.879375983212 },
    { lat: 0.929216213765646, lon: -0.0789034104716222, alt: 39.8793717074672 },
    { lat: 0.929216214117594, lon: -0.0789034099612718, alt: 39.8793684320557 },
    { lat: 0.929216214464412, lon: -0.0789034094583584, alt: 39.8793668876097 },
    { lat: 0.929216214811733, lon: -0.0789034089547177, alt: 39.8793716245476 },
    { lat: 0.929216215168242, lon: -0.0789034084377535, alt: 39.8793902267323 },
    { lat: 0.929216215521658, lon: -0.0789034079252749, alt: 39.8793991859459 },
    { lat: 0.929216215870035, lon: -0.0789034074201034, alt: 39.8794070703446 },
    { lat: 0.929216216218012, lon: -0.0789034069155114, alt: 39.8794110839489 },
    { lat: 0.929216216570926, lon: -0.0789034064037648, alt: 39.8794034764333 },
    { lat: 0.929216216925038, lon: -0.0789034058902769, alt: 39.8793978412785 },
    { lat: 0.929216217278839, lon: -0.0789034053772387, alt: 39.8793962033776 },
    { lat: 0.929216217626624, lon: -0.0789034048729254, alt: 39.8793943074358 },
    { lat: 0.929216217975155, lon: -0.0789034043675273, alt: 39.8794060585363 },
    { lat: 0.929216218328862, lon: -0.0789034038546263, alt: 39.8794195379038 },
    { lat: 0.929216218681829, lon: -0.0789034033427985, alt: 39.8794285322352 },
    { lat: 0.929216219028937, lon: -0.078903402839468, alt: 39.8794347119816 },
    { lat: 0.929216219377133, lon: -0.0789034023345557, alt: 39.8794383070887 },
    { lat: 0.929216219732881, lon: -0.0789034018186928, alt: 39.8794275245102 },
    { lat: 0.929216220084664, lon: -0.078903401308586, alt: 39.879423057883 },
    { lat: 0.929216220432652, lon: -0.0789034008039792, alt: 39.8794225594226 },
    { lat: 0.929216220778898, lon: -0.0789034003018947, alt: 39.8794223334243 },
    { lat: 0.929216221130726, lon: -0.0789033997917191, alt: 39.8794375716602 },
    { lat: 0.929216221483441, lon: -0.0789033992802558, alt: 39.8794497797526 },
    { lat: 0.929216221836605, lon: -0.0789033987681455, alt: 39.8794576866207 },
    { lat: 0.929216222183946, lon: -0.0789033982644766, alt: 39.879463541953 },
    { lat: 0.929216222531128, lon: -0.0789033977610409, alt: 39.8794621728149 },
    { lat: 0.929216222882962, lon: -0.0789033972508539, alt: 39.879452075975 },
    { lat: 0.929216223234866, lon: -0.0789033967405678, alt: 39.8794497193255 },
    { lat: 0.929216223588693, lon: -0.0789033962274957, alt: 39.8794488090447 },
    { lat: 0.929216223933714, lon: -0.0789033957271903, alt: 39.8794516615179 },
    { lat: 0.929216224280932, lon: -0.0789033952236983, alt: 39.8794707886424 },
    { lat: 0.929216224634126, lon: -0.0789033947115391, alt: 39.8794793360276 },
    { lat: 0.929216224991168, lon: -0.0789033941937993, alt: 39.8794875433734 },
    { lat: 0.929216225339477, lon: -0.0789033936887223, alt: 39.8794909361044 },
    { lat: 0.929216225689958, lon: -0.0789033931805026, alt: 39.8794842194429 },
    { lat: 0.929216226042704, lon: -0.0789033926689964, alt: 39.8794783866999 },
    { lat: 0.929216226394094, lon: -0.0789033921594537, alt: 39.879476569358 },
    { lat: 0.92921622674512, lon: -0.0789033916504421, alt: 39.8794763856246 },
    { lat: 0.929216227164267, lon: -0.0789033910425857, alt: 39.8800422510816 },
    { lat: 0.929216235688868, lon: -0.0789033786812867, alt: 39.8817360229038 },
    { lat: 0.929216298821715, lon: -0.0789032873218605, alt: 39.8828285276082 },
    { lat: 0.929216490565375, lon: -0.0789030123977146, alt: 39.8848818922908 },
    { lat: 0.929216900137903, lon: -0.078902434162343, alt: 39.8863982697475 },
    { lat: 0.929217541920839, lon: -0.0789015375779488, alt: 39.8861395377282 },
    { lat: 0.929218330005312, lon: -0.0789004457305704, alt: 39.8934216632626 },
    { lat: 0.929219057126506, lon: -0.0788994423774306, alt: 39.8928031917542 },
    { lat: 0.929219723914357, lon: -0.0788985195557278, alt: 39.888823101854 },
    { lat: 0.929220333609142, lon: -0.0788976935604054, alt: 39.8862773649274 },
    { lat: 0.929220921787909, lon: -0.0788969441731684, alt: 39.8831140358174 },
    { lat: 0.929221491444593, lon: -0.078896296333508, alt: 39.8888303881451 },
    { lat: 0.929221962536754, lon: -0.0788959736759805, alt: 39.8883422225595 },
    { lat: 0.929222276265188, lon: -0.0788959800068846, alt: 39.8885395684433 },
    { lat: 0.92922245069647, lon: -0.078896116115102, alt: 39.8833382764899 },
    { lat: 0.929222666142052, lon: -0.0788963722672887, alt: 39.8847285641065 },
    { lat: 0.929223035618596, lon: -0.0788969065383934, alt: 39.8869517576994 },
    { lat: 0.929223608777833, lon: -0.0788978485706384, alt: 39.888012681555 },
    { lat: 0.929224326678609, lon: -0.0788991108901182, alt: 39.8884196484234 },
    { lat: 0.929224975498185, lon: -0.0789003651480018, alt: 39.8985548109457 },
    { lat: 0.929225411291092, lon: -0.0789012121575076, alt: 39.9043815696433 },
    { lat: 0.929225579547346, lon: -0.0789015273998837, alt: 39.8993743465507 },
    { lat: 0.929225588806184, lon: -0.0789015448073465, alt: 39.8788128950597 },
    { lat: 0.929225590179622, lon: -0.0789015473788097, alt: 39.8893464812423 },
    { lat: 0.929225592618448, lon: -0.0789015519427234, alt: 39.8952724633078 },
    { lat: 0.929225595675602, lon: -0.0789015576634447, alt: 39.8977093214462 },
    { lat: 0.929225613484561, lon: -0.0789015911173143, alt: 39.8905922795669 },
    { lat: 0.929225781197191, lon: -0.0789019093706434, alt: 39.8871326527423 },
    { lat: 0.929226236933018, lon: -0.078902794049534, alt: 39.8920016423146 },
    { lat: 0.929227076368207, lon: -0.0789044658672716, alt: 39.8980351986842 },
    { lat: 0.929228301920284, lon: -0.0789069455020087, alt: 39.9055489904912 },
    { lat: 0.929229851898617, lon: -0.0789100709482692, alt: 39.9152608544248 },
    { lat: 0.929231749367593, lon: -0.0789138596468383, alt: 39.9269738382935 },
    { lat: 0.929234037180178, lon: -0.078918366870342, alt: 39.9405857908567 },
    { lat: 0.929236672913603, lon: -0.0789235109017971, alt: 39.955433954132 },
    { lat: 0.929239588078214, lon: -0.0789291819138893, alt: 39.9716171566735 },
    { lat: 0.929242821157557, lon: -0.0789354682888903, alt: 39.9889787348583 },
    { lat: 0.92924642744161, lon: -0.0789424717696041, alt: 40.0118588237118 },
    { lat: 0.929250339046512, lon: -0.0789500621602446, alt: 40.0325667700485 },
    { lat: 0.929254474112132, lon: -0.078958085576352, alt: 40.0545077306003 },
    { lat: 0.929258890154346, lon: -0.0789666515421691, alt: 40.080129187756 },
    { lat: 0.929263650709522, lon: -0.078975879049103, alt: 40.1100060692267 },
    { lat: 0.929268681264469, lon: -0.0789856281535586, alt: 40.1546064777299 },
    { lat: 0.929273962594125, lon: -0.0789958654916204, alt: 40.2110507889794 },
    { lat: 0.929279397932675, lon: -0.07900639953906, alt: 40.1883028986122 },
    { lat: 0.929285060593744, lon: -0.0790173623291447, alt: 41.0604240804627 },
    { lat: 0.929291023998039, lon: -0.0790289002741146, alt: 45.4610624585727 },
    { lat: 0.929297164162452, lon: -0.0790407746925119, alt: 52.7677618034127 },
    { lat: 0.929303358558276, lon: -0.0790527477385682, alt: 62.0612218552263 },
    { lat: 0.929309716271221, lon: -0.0790650290597499, alt: 73.3861421888871 },
    { lat: 0.929316315219037, lon: -0.0790777763859827, alt: 84.9209721639483 },
    { lat: 0.929323063489057, lon: -0.0790908350746229, alt: 97.5130847914218 },
    { lat: 0.92932982462153, lon: -0.0791039737761192, alt: 113.018033278911 },
    { lat: 0.929336702363083, lon: -0.0791174267447174, alt: 131.213815365563 },
    { lat: 0.92934378605948, lon: -0.0791313970153608, alt: 153.25476422927 },
    { lat: 0.929350906802939, lon: -0.0791455609722049, alt: 179.696055473584 },
    { lat: 0.929358059804244, lon: -0.0791599007816738, alt: 208.238807000362 },
    { lat: 0.929365341890775, lon: -0.0791746051863245, alt: 237.19387607157 },
    { lat: 0.929372569465766, lon: -0.0791893029162083, alt: 265.908449865703 },
    { lat: 0.929379853982982, lon: -0.0792042241121348, alt: 295.810177252194 },
    { lat: 0.92938730039715, lon: -0.0792195913629535, alt: 328.547620694194 },
    { lat: 0.92939477930323, lon: -0.0792351404700125, alt: 363.154374350092 },
    { lat: 0.929402166465601, lon: -0.0792506077800678, alt: 398.027826834277 },
    { lat: 0.929409581150111, lon: -0.0792662451565766, alt: 434.401473165798 },
    { lat: 0.929417123280225, lon: -0.0792822700885252, alt: 473.762697325234 },
    { lat: 0.929424680097706, lon: -0.0792984375900899, alt: 512.960344550373 },
    { lat: 0.92943217631058, lon: -0.0793145865226145, alt: 551.677804928095 },
    { lat: 0.929439764004549, lon: -0.0793310541165413, alt: 593.087437564809 },
    { lat: 0.929447279036306, lon: -0.0793472632505281, alt: 635.620878150131 },
    { lat: 0.929455433634714, lon: -0.0793626351677396, alt: 677.109958023082 },
    { lat: 0.929464940373383, lon: -0.0793762383089115, alt: 718.109805847042 },
    { lat: 0.929475542901475, lon: -0.0793877057216991, alt: 749.099832903835 },
    { lat: 0.929487017973384, lon: -0.0793962276473306, alt: 771.26765741562 },
    { lat: 0.929499323126796, lon: -0.0794014738210114, alt: 786.093435161947 },
    { lat: 0.92951234149798, lon: -0.0794026377994067, alt: 796.941549224963 },
    { lat: 0.92952536408631, lon: -0.0793992195370802, alt: 804.418195933115 },
    { lat: 0.92953752223554, lon: -0.0793911388407388, alt: 810.133528749114 },
    { lat: 0.929548278900979, lon: -0.0793784079269468, alt: 815.698760584651 },
    { lat: 0.929557045765785, lon: -0.0793612805526949, alt: 821.888555712376 },
    { lat: 0.929563100287612, lon: -0.0793413141855159, alt: 827.278959777609 },
    { lat: 0.929566469831769, lon: -0.0793193811348041, alt: 830.247250414979 },
    { lat: 0.929566893801871, lon: -0.079296200670008, alt: 833.63507288069 },
    { lat: 0.929564440849351, lon: -0.0792737681279348, alt: 841.913317782726 },
    { lat: 0.929559493960691, lon: -0.0792520541610902, alt: 857.997769036899 },
    { lat: 0.929553019120278, lon: -0.0792321487556875, alt: 881.212330334799 },
    { lat: 0.929545524393836, lon: -0.0792135052162432, alt: 913.75053772225 },
    { lat: 0.929537484655179, lon: -0.0791951868983806, alt: 951.214478279687 },
    { lat: 0.929529423117102, lon: -0.0791772734410286, alt: 989.026005733207 },
    { lat: 0.929521372675888, lon: -0.0791593848922552, alt: 1027.1634949488 },
    { lat: 0.929513495573157, lon: -0.0791418098024589, alt: 1060.58059301592 },
    { lat: 0.929505665857215, lon: -0.079124281673318, alt: 1083.48993305545 },
    { lat: 0.929497726649375, lon: -0.0791064595542299, alt: 1093.10595048869 },
    { lat: 0.929489802324712, lon: -0.0790886573386305, alt: 1092.11649034048 },
    { lat: 0.929482024002774, lon: -0.0790711987661905, alt: 1087.49876058469 },
    { lat: 0.929474217370259, lon: -0.0790536990385621, alt: 1085.93647751725 },
    { lat: 0.92946645443528, lon: -0.0790363200930962, alt: 1085.11713783916 },
    { lat: 0.929458801201433, lon: -0.079019210070729, alt: 1086.01510635027 },
    { lat: 0.929451123866898, lon: -0.0790020206211994, alt: 1088.66838982367 },
    { lat: 0.929443622580273, lon: -0.0789850907833704, alt: 1091.74695934602 },
    { lat: 0.92943641753831, lon: -0.0789686643590653, alt: 1095.05247814188 },
    { lat: 0.929429403651755, lon: -0.0789524371684746, alt: 1097.68030365044 },
    { lat: 0.929422552780376, lon: -0.078936066967541, alt: 1099.15796304509 },
    { lat: 0.929416140297087, lon: -0.0789200493646547, alt: 1100.90117972426 },
    { lat: 0.929410037546273, lon: -0.0789041261910961, alt: 1101.5423445119 },
    { lat: 0.929404046333091, lon: -0.0788880340207835, alt: 1098.39364444765 },
    { lat: 0.929398192708373, lon: -0.078872202956723, alt: 1095.08687249862 },
    { lat: 0.92939254352632, lon: -0.0788569869877693, alt: 1094.25016978131 },
    { lat: 0.929387020339709, lon: -0.0788421618446205, alt: 1095.05942715833 },
    { lat: 0.929381540153678, lon: -0.0788274706765717, alt: 1096.95359427488 },
    { lat: 0.929376264835043, lon: -0.0788133135235777, alt: 1097.88469522854 },
    { lat: 0.929371094026833, lon: -0.0787994043671903, alt: 1097.04942151623 },
    { lat: 0.92936596166227, lon: -0.0787855615397179, alt: 1095.20237171926 },
    { lat: 0.929360920538386, lon: -0.0787719261226059, alt: 1092.35304408207 },
    { lat: 0.92935595332652, lon: -0.0787584508877674, alt: 1088.22197857434 },
    { lat: 0.929351130195202, lon: -0.0787453268000079, alt: 1082.72104234875 },
    { lat: 0.929346360470886, lon: -0.0787323071346446, alt: 1075.93377405783 },
    { lat: 0.929341564084923, lon: -0.0787191708493404, alt: 1069.29812545962 },
    { lat: 0.92933689926158, lon: -0.0787063519509147, alt: 1062.15807523597 },
    { lat: 0.929332265994065, lon: -0.0786935719333236, alt: 1054.49541575276 },
    { lat: 0.929327554532356, lon: -0.0786805165931394, alt: 1046.40498643673 },
    { lat: 0.929322781775521, lon: -0.078667212950354, alt: 1038.92107618951 },
    { lat: 0.929317985709463, lon: -0.0786537603132225, alt: 1031.91564848002 },
    { lat: 0.929313118759978, lon: -0.0786400230644296, alt: 1026.47175286447 },
    { lat: 0.929308102131635, lon: -0.0786257769915388, alt: 1023.24598281211 },
    { lat: 0.929303118955425, lon: -0.0786115453705196, alt: 1021.80805658509 },
    { lat: 0.92929808841589, lon: -0.0785971020440121, alt: 1021.55201859816 },
    { lat: 0.929292935178395, lon: -0.0785822330812705, alt: 1021.28044247434 },
    { lat: 0.92928773672131, lon: -0.0785671616428244, alt: 1020.28329695292 },
    { lat: 0.929282503821599, lon: -0.078551917227872, alt: 1020.0193410749 },
    { lat: 0.929277350559157, lon: -0.0785368385163644, alt: 1020.452678561 },
    { lat: 0.929272227982009, lon: -0.0785217891867002, alt: 1021.19337650967 },
    { lat: 0.929267055165844, lon: -0.0785065342114716, alt: 1022.15359857899 },
    { lat: 0.929261908926304, lon: -0.0784915006334067, alt: 1023.94624529289 },
    { lat: 0.929256612345743, lon: -0.0784772800681245, alt: 1022.96478908035 },
    { lat: 0.929250783963308, lon: -0.0784639327224305, alt: 1014.08719917061 },
    { lat: 0.929244133510085, lon: -0.0784515391759444, alt: 996.711998369534 },
    { lat: 0.92923658447406, lon: -0.0784409202377619, alt: 976.550285548688 },
    { lat: 0.92922836973742, lon: -0.0784325120369188, alt: 954.906614109227 },
    { lat: 0.929219534426361, lon: -0.0784264314037526, alt: 932.452997755397 },
    { lat: 0.929210140428381, lon: -0.0784226976647012, alt: 907.839809582247 },
    { lat: 0.929200575645391, lon: -0.0784215956785671, alt: 882.152612571883 },
    { lat: 0.929191253207372, lon: -0.078423040475602, alt: 856.129065224446 },
    { lat: 0.929182190103159, lon: -0.078426720963852, alt: 827.271535163423 },
    { lat: 0.929173416081126, lon: -0.0784326155707293, alt: 795.707901784831 },
    { lat: 0.929165201426191, lon: -0.0784404436282659, alt: 761.010034344486 },
    { lat: 0.929157751036556, lon: -0.0784497645483727, alt: 723.298923468356 },
    { lat: 0.929150976960773, lon: -0.0784605342632493, alt: 683.788199857549 },
    { lat: 0.929144810811369, lon: -0.0784727946492029, alt: 644.789864609631 },
    { lat: 0.929139426100821, lon: -0.0784861357555758, alt: 608.842717361734 },
    { lat: 0.929134912551894, lon: -0.0785001029857284, alt: 577.137995877505 },
    { lat: 0.929131159083344, lon: -0.0785147390016501, alt: 550.499378475454 },
    { lat: 0.929128014866679, lon: -0.0785300404519017, alt: 528.714529375363 },
    { lat: 0.929125383253636, lon: -0.0785455382802126, alt: 510.267032181619 },
    { lat: 0.929123179488045, lon: -0.0785608488736956, alt: 493.391528915498 },
    { lat: 0.929121313623922, lon: -0.078576160340257, alt: 475.89031449257 },
    { lat: 0.929119822626066, lon: -0.0785917145175544, alt: 455.715741187668 },
    { lat: 0.929119071545389, lon: -0.0786072655512573, alt: 433.008565957462 },
    { lat: 0.929119390471554, lon: -0.078622473478179, alt: 408.07651070414 },
    { lat: 0.929120932095627, lon: -0.0786374024088193, alt: 380.982151061417 },
    { lat: 0.92912369053827, lon: -0.0786520430198665, alt: 353.666355853299 },
    { lat: 0.929127308561585, lon: -0.0786661334118262, alt: 328.219522140203 },
    { lat: 0.929131357937255, lon: -0.0786798698238685, alt: 306.012077543842 },
    { lat: 0.929135438592009, lon: -0.078693226713795, alt: 288.058469875739 },
    { lat: 0.929139507754736, lon: -0.0787064808026945, alt: 272.334630361316 },
    { lat: 0.929143624267673, lon: -0.0787198376919196, alt: 257.164376772229 },
    { lat: 0.929147786614988, lon: -0.0787330495656448, alt: 240.787147074372 },
    { lat: 0.929152104232033, lon: -0.0787456791442828, alt: 223.248810992331 },
    { lat: 0.929156753601102, lon: -0.0787577963709174, alt: 205.228528099115 },
    { lat: 0.929161783297221, lon: -0.0787695711136725, alt: 186.122921879552 },
    { lat: 0.92916692136517, lon: -0.0787807428828716, alt: 168.050102726355 },
    { lat: 0.929172094781153, lon: -0.0787916833444551, alt: 151.656236329959 },
    { lat: 0.929177286568461, lon: -0.0788026839304049, alt: 135.003809078294 },
    { lat: 0.929182407594535, lon: -0.0788135619727292, alt: 117.676303800318 },
    { lat: 0.929187514182143, lon: -0.0788242316489444, alt: 102.362113167966 },
    { lat: 0.929192544517369, lon: -0.0788344759969368, alt: 89.2665376225139 },
    { lat: 0.92919756606835, lon: -0.0788444814329354, alt: 77.2746583298676 },
    { lat: 0.929202630313479, lon: -0.0788544721473194, alt: 65.4832418714713 },
    { lat: 0.929207634416522, lon: -0.0788643443736911, alt: 54.4223546286007 },
    { lat: 0.929212485709302, lon: -0.078873942153611, alt: 45.7539686449384 },
    { lat: 0.929217247204688, lon: -0.0788833700408196, alt: 40.5500568164799 },
    { lat: 0.929222000261193, lon: -0.0788927804307957, alt: 40.1553038952434 },
    { lat: 0.929226658667697, lon: -0.0789020294369889, alt: 40.1278606556129 },
    { lat: 0.929231198522342, lon: -0.0789110717206138, alt: 40.1190376702092 },
    { lat: 0.929235612348976, lon: -0.0789198898198477, alt: 40.1196821146049 },
    { lat: 0.929240090199049, lon: -0.0789288566059419, alt: 40.1303786468838 },
    { lat: 0.929244704815011, lon: -0.0789380977105293, alt: 40.1272960557764 },
    { lat: 0.929249223868436, lon: -0.0789471343291375, alt: 40.1091707440634 },
    { lat: 0.929253491056021, lon: -0.0789556676815075, alt: 40.0890363094537 },
    { lat: 0.929257561307489, lon: -0.0789637819077828, alt: 40.0687139944751 },
    { lat: 0.929261484875822, lon: -0.0789715859418021, alt: 40.0483519313824 },
    { lat: 0.929265169100125, lon: -0.0789789119821005, alt: 40.0287395416914 },
    { lat: 0.929268556418706, lon: -0.0789856362605031, alt: 40.0104200413649 },
    { lat: 0.929271740303023, lon: -0.0789919199362137, alt: 39.9930774225819 },
    { lat: 0.929274660845921, lon: -0.078997652631482, alt: 39.9771993418858 },
    { lat: 0.929277293899118, lon: -0.0790028105965621, alt: 39.9624318531228 },
    { lat: 0.92927968726621, lon: -0.0790074970109918, alt: 39.94981649556 },
    { lat: 0.929281762442561, lon: -0.0790115587569163, alt: 39.9375106132351 },
    { lat: 0.929283637831061, lon: -0.0790152161356392, alt: 39.9208090081011 },
    { lat: 0.92928550056526, lon: -0.0790188199208111, alt: 39.9198486660136 },
    { lat: 0.929287296323856, lon: -0.0790222811539696, alt: 39.9179877907361 },
    { lat: 0.92928905245395, lon: -0.0790256530531452, alt: 39.916346641825 },
    { lat: 0.929290803662686, lon: -0.0790290009461731, alt: 39.9148847241824 },
    { lat: 0.929292486795219, lon: -0.0790322155641028, alt: 39.9140354156372 },
    { lat: 0.929294037687811, lon: -0.079035204254536, alt: 39.921227762164 },
    { lat: 0.929295432092222, lon: -0.0790379459017176, alt: 39.902296768038 },
    { lat: 0.929296776283907, lon: -0.0790406256798413, alt: 39.902966293956 },
    { lat: 0.929298000055375, lon: -0.0790432409747953, alt: 39.9011057872744 },
    { lat: 0.929298999530538, lon: -0.079045944235052, alt: 39.8997092232292 },
    { lat: 0.929299712824939, lon: -0.0790487406359962, alt: 39.8975477986796 },
    { lat: 0.929300097063011, lon: -0.0790515284736205, alt: 39.8967168481829 },
    { lat: 0.929300202219957, lon: -0.0790541789792648, alt: 39.8949224241302 },
    { lat: 0.929300068854841, lon: -0.079056658357326, alt: 39.8947102620005 },
    { lat: 0.929299719198729, lon: -0.0790589016767265, alt: 39.8935324455237 },
    { lat: 0.929299135648952, lon: -0.079060755645663, alt: 39.8909870668051 },
    { lat: 0.929298424143713, lon: -0.0790622494736569, alt: 39.8897279241241 },
    { lat: 0.929297655434601, lon: -0.0790635527216063, alt: 39.8879308601415 },
    { lat: 0.929296888786488, lon: -0.0790648447839814, alt: 39.8877997116047 },
    { lat: 0.929296158171983, lon: -0.0790661062975325, alt: 39.8882889565682 },
    { lat: 0.929295466091881, lon: -0.0790672187442292, alt: 39.9004408405342 },
    { lat: 0.929295128127368, lon: -0.0790676983675665, alt: 39.9028718701105 },
];
